import { render } from "./EditStudent.vue?vue&type=template&id=201f213a&scoped=true"
import script from "./EditStudent.vue?vue&type=script&lang=js"
export * from "./EditStudent.vue?vue&type=script&lang=js"

import "./EditStudent.vue?vue&type=style&index=0&id=201f213a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201f213a"]])

export default __exports__